import { EventManagerPlugin } from '@angular/platform-browser';

export class PreventDefaultEventPlugin extends EventManagerPlugin {
  override supports(eventName: string): boolean {
    return eventName.endsWith('.prevent');
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  override addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    return this.manager.addEventListener(
      element,
      eventName.replace('.prevent', ''),
      (event: Event) => {
        event.preventDefault();
        handler(event);
      },
    );
  }
}
